import { PayoutsListSection } from "../../../prop-firm-manager/PayoutsListSection";

export default function PropFirmPayoutsListWidget() {
  return (
    <div className="h-full overflow-auto">
      <PayoutsListSection />
    </div>
  );
}
